module.exports = __webpack_public_path__ + "static/media/20.021.3cdab5a9.webp";